export default class Dot {
  static get(object, path) {
    if (object === undefined || typeof object !== 'object') {
      return null
    }
    if (typeof path === "string") {
      path = path.split(".")
    }
    const currentPath = path.shift()

    if (!path.length) {
      return object[currentPath] !== undefined
        ? object[currentPath]
        : null
    }
    return typeof object[currentPath] == "object"
      ? this.get(object[currentPath], path)
      : null
  }
}
